import { getValidToken } from "@/modules/auth/utils/getValidToken"
import { HUError, HUErrorCode } from "@/modules/error/huError"
import { Lock } from "@modules/core/Lock"
import { type ApiInterceptor } from "@modules/core/api/interceptors/apiInterceptor"
import { type AxiosInstance, type AxiosResponse, isAxiosError } from "axios"
import _ from "lodash"

export const responseUnauthorizeErrorFallbackInterceptor = (
  axios: Readonly<AxiosInstance>,
  tokenRefreshingLock: Lock,
): ApiInterceptor<AxiosResponse> => ({
  onRejected: async (error) => {
    if (isAxiosError(error) && error.response?.status === 401 && !_.get(error, "config.__isRetry")) {
      if (tokenRefreshingLock.exist()) {
        await tokenRefreshingLock.isReleased()
        return await axios.request(error.response.config)
      } else {
        tokenRefreshingLock.create()
        try {
          _.set(error, "config.__isRetry", true)
          await getValidToken(true)
          // keep this request first -> do request before release lock
          const result = axios.request(error.response.config)
          tokenRefreshingLock.release()
          return await result
        } catch (e) {
          tokenRefreshingLock.release(e)
          return Promise.reject(new HUError(HUErrorCode.Unauthorised, "Unauthorised"))
        }
      }
    }

    const rejectReason = error instanceof Error ? error : new Error(String(error))
    return Promise.reject(rejectReason)
  },
})
